import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export default function EmptyState({
  title,
  description,
  action,
  className,
}: {
  title: string
  description?: string
  action?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex flex-col items-start gap-2 px-6 py-8', className)} role="status">
      <h2 className="text-base font-semibold text-foreground">{title}</h2>
      {description ? <p className="max-w-prose text-sm text-muted-foreground">{description}</p> : null}
      {action}
    </div>
  )
}
